export default function StatusBadge({ status }) {
  const styles = {
    new: "bg-blue-50 text-blue-800 ring-blue-200",
    pending: "bg-amber-50 text-amber-800 ring-amber-200",
    referred: "bg-purple-50 text-purple-800 ring-purple-200",
    closed: "bg-emerald-50 text-emerald-800 ring-emerald-200",
    urgent: "bg-red-50 text-red-800 ring-red-200"
  };

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ${styles[status] || styles.new}`}>
      {status}
    </span>
  );
}
